export class RestoreGcpInstanceDiskInput {
    'providerDiskId';
    'settings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "GcpDiskSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGcpInstanceDiskInput.attributeTypeMap;
    }
    constructor() {
    }
}
